<template>
  <div>
    <div
      class="flex flex-col items-center min-h-80 max-w-64 pb-6 ml-auto rounded-[10px] bg-gray-f9 text-black sticky top-32 mb-20"
    >
      <div class="w-[147px]">
        <!-- Logo -->
        <div class="hidden mb-4 mt-4">
          <img
            :src="company_src" 
            :alt="company_name"
            class="w-[75px] h-[75px] rounded-full bg-cover"
          >
        </div>

        <!-- Foto del agente -->
        <div class="mb-4 mt-4 flex justify-center">
          <img
            :src="broker_src" 
            :alt="broker_name"
            class="w-[75px] h-[75px] rounded-full bg-cover"
          >
        </div>

        <!-- Nombre del agente -->
        <h2 class="text-base font-normal mb-1 items-center text-center">
          {{ broker_name }} 
        </h2>

        <!-- Nombre de la inmobiliaria -->
        <h1 class="text-sm font-normal mb-2 items-center text-center"> 
          {{ company_name }} 
        </h1>

        <!-- Botones -->
        <div class="flex flex-col gap-2">
          <!-- Botón Llamada -->
          <a
            :href="broker_phone"
            target="_blank"
            @click="callActionLog(property_id, 17, detail_message_call)"
            rel="noopener noreferrer"
            type="button"
            class="group text-tuin-100 border border-tuin-100 hover:bg-tuin-100 hover:text-white focus:outline-none focus:ring-0 font-medium rounded-lg text-sm w-full py-2.5 px-4 text-center flex justify-center items-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="mr-2">
              <path d="M16.629 13.891L17.085 13.438L16.026 12.374L15.572 12.827L16.629 13.891ZM18.614 13.248L20.525 14.287L21.24 12.969L19.33 11.931L18.614 13.248ZM20.892 16.351L19.472 17.764L20.529 18.827L21.949 17.415L20.892 16.351ZM18.606 18.218C17.156 18.354 13.406 18.233 9.34399 14.195L8.28599 15.258C12.718 19.665 16.937 19.881 18.746 19.712L18.606 18.218ZM9.34399 14.195C5.47299 10.345 4.83099 7.10796 4.75099 5.70296L3.25299 5.78796C3.35299 7.55596 4.14799 11.144 8.28599 15.258L9.34399 14.195ZM10.719 8.01496L11.006 7.72896L9.94999 6.66596L9.66299 6.95096L10.719 8.01496ZM11.234 4.09396L9.97399 2.40996L8.77299 3.30996L10.033 4.99296L11.234 4.09396ZM5.73299 2.04296L4.16299 3.60296L5.22099 4.66696L6.78999 3.10696L5.73299 2.04296ZM10.191 7.48296C9.66099 6.95096 9.66099 6.95096 9.66099 6.95296H9.65899L9.65599 6.95696C9.60847 7.00487 9.56592 7.05748 9.52899 7.11396C9.47499 7.19396 9.41599 7.29896 9.36599 7.43196C9.24427 7.77529 9.21394 8.14437 9.27799 8.50296C9.41199 9.36796 10.008 10.511 11.534 12.029L12.592 10.965C11.163 9.54496 10.823 8.68096 10.76 8.27296C10.73 8.07896 10.761 7.98296 10.77 7.96096C10.776 7.94763 10.776 7.94563 10.77 7.95496C10.7611 7.96876 10.751 7.9818 10.74 7.99396L10.73 8.00396L10.72 8.01296L10.191 7.48296ZM11.534 12.029C13.061 13.547 14.21 14.139 15.076 14.271C15.519 14.339 15.876 14.285 16.147 14.184C16.2988 14.1284 16.4406 14.0487 16.567 13.948L16.617 13.903L16.624 13.897L16.627 13.894L16.628 13.892C16.628 13.892 16.629 13.891 16.1 13.359C15.57 12.827 15.573 12.826 15.573 12.826L15.575 12.824L15.577 12.822L15.583 12.817L15.593 12.807L15.631 12.777C15.6403 12.771 15.638 12.7716 15.624 12.779C15.599 12.788 15.501 12.819 15.304 12.789C14.89 12.725 14.02 12.385 12.592 10.965L11.534 12.029ZM9.97399 2.40896C8.95399 1.04896 6.94999 0.83296 5.73299 2.04296L6.78999 3.10696C7.32199 2.57796 8.26599 2.63296 8.77299 3.30996L9.97399 2.40896ZM4.75199 5.70396C4.73199 5.35796 4.89099 4.99596 5.22099 4.66796L4.16199 3.60396C3.62499 4.13796 3.20199 4.89396 3.25299 5.78796L4.75199 5.70396ZM19.472 17.764C19.198 18.038 18.902 18.192 18.607 18.219L18.746 19.712C19.481 19.643 20.082 19.273 20.53 18.828L19.472 17.764ZM11.006 7.72896C11.991 6.74996 12.064 5.20296 11.235 4.09496L10.034 4.99396C10.437 5.53296 10.377 6.23996 9.94899 6.66696L11.006 7.72896ZM20.526 14.288C21.343 14.732 21.47 15.778 20.893 16.352L21.951 17.415C23.291 16.082 22.878 13.859 21.241 12.97L20.526 14.288ZM17.085 13.439C17.469 13.057 18.087 12.963 18.615 13.249L19.331 11.932C18.247 11.342 16.903 11.505 16.027 12.375L17.085 13.439Z" class="fill-tuin-100 group-hover:fill-white"/>
            </svg>
            Llamar
          </a>
          <!-- Botón WhatsApp -->
          <a
            :href="broker_wp"
            @click="callActionLog(property_id, 16, detail_message_wp)"
            target="_blank"
            type="button" 
            class="group text-what border border-what hover:bg-what hover:text-white focus:outline-none focus:ring-0 font-medium rounded-lg text-sm w-full py-2.5 px-4 text-center flex justify-center items-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="mr-2">
              <path d="M19.05 4.91005C18.1331 3.98416 17.041 3.25002 15.8375 2.75042C14.634 2.25081 13.3431 1.99574 12.04 2.00005C6.57999 2.00005 2.12999 6.45005 2.12999 11.9101C2.12999 13.6601 2.58999 15.3601 3.44999 16.8601L2.04999 22.0001L7.29999 20.6201C8.74999 21.4101 10.38 21.8301 12.04 21.8301C17.5 21.8301 21.95 17.3801 21.95 11.9201C21.95 9.27005 20.92 6.78005 19.05 4.91005ZM12.04 20.1501C10.56 20.1501 9.10999 19.7501 7.83999 19.0001L7.53999 18.8201L4.41999 19.6401L5.24999 16.6001L5.04999 16.2901C4.22754 14.9771 3.79091 13.4593 3.78999 11.9101C3.78999 7.37005 7.48999 3.67005 12.03 3.67005C14.23 3.67005 16.3 4.53005 17.85 6.09005C18.6176 6.85392 19.2259 7.7626 19.6396 8.76338C20.0533 9.76417 20.2642 10.8371 20.26 11.9201C20.28 16.4601 16.58 20.1501 12.04 20.1501ZM16.56 13.9901C16.31 13.8701 15.09 13.2701 14.87 13.1801C14.64 13.1001 14.48 13.0601 14.31 13.3001C14.14 13.5501 13.67 14.1101 13.53 14.2701C13.39 14.4401 13.24 14.4601 12.99 14.3301C12.74 14.2101 11.94 13.9401 11 13.1001C10.26 12.4401 9.76999 11.6301 9.61999 11.3801C9.47999 11.1301 9.59999 11.0001 9.72999 10.8701C9.83999 10.7601 9.97999 10.5801 10.1 10.4401C10.22 10.3001 10.27 10.1901 10.35 10.0301C10.43 9.86005 10.39 9.72005 10.33 9.60005C10.27 9.48005 9.76999 8.26005 9.56999 7.76005C9.36999 7.28005 9.15999 7.34005 9.00999 7.33005H8.52999C8.35999 7.33005 8.09999 7.39005 7.86999 7.64005C7.64999 7.89005 7.00999 8.49005 7.00999 9.71005C7.00999 10.9301 7.89999 12.1101 8.01999 12.2701C8.13999 12.4401 9.76999 14.9401 12.25 16.0101C12.84 16.2701 13.3 16.4201 13.66 16.5301C14.25 16.7201 14.79 16.6901 15.22 16.6301C15.7 16.5601 16.69 16.0301 16.89 15.4501C17.1 14.8701 17.1 14.3801 17.03 14.2701C16.96 14.1601 16.81 14.1101 16.56 13.9901Z" class="fill-[#4BA142] group-hover:fill-white"/>
            </svg>
            WhatsApp
          </a>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script setup>
  import { defineProps, ref, watch, computed } from "vue";
  import axios from "axios";
  import { useStore } from "vuex";
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);

  const props = defineProps({
      broker: {
        type: Object,
        required: true,
        default: () => ({ property_name: '' })
      },
      propertyId:{
        type: Number,
        required: true,
        default: null,
      },
      slugUrl: {
        type: String,
        required: true,  // O puedes hacer que no sea requerido, si prefieres
        default: null  // Valor predeterminado vacío si no se pasa el slug_url
      }
  });

  let company_src = ref(require("@/assets/imgs/broker_default.png"));
  let broker_src = ref(require('@/assets/imgs/broker_default.png'));
  let company_name = ref('tuin');
  let broker_name = ref('');
  let broker_phone = ref('');
  let broker_id = ref('');
  let broker_wp = ref('');
  let property_id = ref('');

  let detail_message_wp = ref('');
  let detail_message_call = ref('');

  async function callActionLog(property_id, type_action, detail){

    let link = `${process.env.VUE_APP_API_BASE_URL}/event/add_log`;
    let param_analytics = {
          "property_id":          property_id,
          "user_id":              session.value.id,
          "agent_id":             broker_id.value,
          "activity_id":          type_action,
          "description":          detail,          
    }
    console.log(param_analytics)

    let options = {
      headers: {
        "Content-Type": "application/json"
      },
    };

    try {
      const response = await axios.post(link, param_analytics, options);

      if (response.status == 401) {
        //console.log("Hay que sacarlo de la sesion ");
      }

      if (response.status == 200) {
        console.log(response);
      }
      
    } catch (error) {
      console.error("Error fetching data:", error);
    }

  }

  watch(      
      () => [props.broker, props.propertyId] ,  
      async ([newVal, newValProperty ]) => {
        property_id.value = newValProperty;

        detail_message_wp.value = `Contacto vía whatsapp Asesor inmobiliario contacta: ${session.value.name} con id:${session.value.id} contacto al asesor inmobiliario contactado: ${newVal.full_name} con id:${newVal.id}`;
        detail_message_call.value = `Contacto vía llamada Asesor inmobiliario contacta: ${session.value.name} con id:${session.value.id} contacto al asesor inmobiliario contactado: ${newVal.full_name} con id:${newVal.id}`;

        if(newVal.company && newVal.company.logo){
          company_src.value = newVal.company.logo 
          company_name.value                = newVal && newVal.company.name                   != null ? newVal.company.name : 'Tuin';
        }

        if(newVal && newVal.profile_avatar){
          broker_src.value = newVal.profile_avatar;
        }

          
          broker_name.value                 = newVal && newVal.full_name                      != null ? newVal.full_name : '';
          broker_id.value                   = newVal && newVal.id                             != null ? newVal.id : '';
          console.log(broker_id);
          broker_phone.value                = newVal && newVal.phone                          != null ? 'tel:+'+newVal.phone : '';   
          broker_wp.value                   = newVal && newVal.phone                          != null ?  `https://wa.me/52${ newVal.phone   }?text=Hola%20he%20visto%20tu%20propiedad%20en%20Tuin%20y%20quisiera%20más%20información:%20${props.slugUrl}`: '';          
      },
      { immediate: true }
    );
  
</script>
